import { render, staticRenderFns } from "./GhsItem.vue?vue&type=template&id=b06e4488&scoped=true&"
import script from "./GhsItem.vue?vue&type=script&lang=js&"
export * from "./GhsItem.vue?vue&type=script&lang=js&"
import style0 from "./GhsItem.vue?vue&type=style&index=0&id=b06e4488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06e4488",
  null
  
)

export default component.exports